/**
* @file 战队-奖励发放
* @author 余凯
*/

import React from 'react'
import { Table, Descriptions, InputNumber, Button, Modal, message } from 'antd'
import './index.less'

import { connect } from 'react-redux'

import Actions from '../../../../apis/team'

const { confirm } = Modal;

const columns = [
  {
    title: '道具名称',
    dataIndex: 'item_name',
    // width: 150,
  },
  {
    title: '仓库数量',
    dataIndex: 'item_count',
    // width: 150,
  },
];
const userColumns = [

  {
    title: '发放对象',
    dataIndex: 'nickname',
    // width: 150,
  },
];

const userData = [];
for (let i = 0; i < 100; i++) {
  userData.push({
    key: i,
    name: `Edward King ${i}`,
  });
}

@connect(
  state => state.teamReducer,

)
class AwardDistribution extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKey: '', // 选中物品 单选选
      selectedRowKeys: [], // 选中用户 多选
      loading: false,
      count: 1,
      goodsList: [],
      goods: {},
      memberList: [],
      users: []
    }
  }

  componentDidMount = () => {
    this.getGoodsList()
    this.getMemberList()
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, users: selectedRows });
  };

  onGoodsSelectChange = (selectedRowKey, selectedRows) => {
    this.setState({ selectedRowKey, goods: selectedRows[0] });
  };

  onChange = (value) => {
    this.setState({ count: value })
  }

  handleSubmit = () => {
    const { selectedRowKeys, goods, count, users } = this.state;
    const _this = this
    if (goods.item_count < (count * selectedRowKeys.length)) {
      return message.error('物品数量不足')
    }
    if (goods.item_name && count && selectedRowKeys.length) {
      confirm({
        title: '确认发放奖励',
        // icon: <ExclamationCircleOutlined />,
        content: (
          <Descriptions column={1}>
            <Descriptions.Item label="发放物品">{goods.item_name}</Descriptions.Item>
            <Descriptions.Item label="每人发放数量：">
              {count}
            </Descriptions.Item>
            <Descriptions.Item label="发放数量">
              {count * selectedRowKeys.length}
            </Descriptions.Item>
            <Descriptions.Item className="userlabel" label="发放用户">

              {users.map((v, i) => <div key={i}>{v.nickname}</div>)}

            </Descriptions.Item>
          </Descriptions>),
        okText: '确认',
        cancelText: '取消',
        onOk() {
          const params = {
            id: _this.props.userInfo.game_team_id,
            game_id: _this.props.game,
            item_id: goods.item_id,
            every_number: count,
            user_ids: selectedRowKeys
          }
          Actions.postAwardDistribution(params).then(res => {
            if (res.code == 200) {
              message.success('成功发送奖励')
              _this.getGoodsList()
              _this.setState({ selectedRowKeys: [] });
            }
          })
        },
        onCancel() {
          // console.log('Cancel');
        },
      });
    }
  }

  getGoodsList = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
    }
    const res = await Actions.getTeamGoodsList(params)
    if (res.code == 200) {
      this.setState({
        goodsList: res.data
      })
    }
  }

  getMemberList = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      page_size: 9999
    }
    const res = await Actions.getMemberList(params)
    if (res.code == 200) {
      this.setState({
        memberList: res.data.list.map(v => ({ ...v, key: v.user_id }))
      })
    }
  }

  handleGoodsRow = (item) => {
    return {
      onClick: (event) => {
        const { selectedRowKey, goods } = this.state
        this.setState({
          selectedRowKey: [item.item_id],
          goods: item
        })
      }
    };
  }

  handleUsersRow = (item, i) => {
    return {
      onClick: event => {
        const { selectedRowKeys, users } = this.state
        const i = selectedRowKeys.indexOf(item.user_id)
        if (i > -1) {
          selectedRowKeys.splice(i, 1)
          users.splice(i, 1)
          this.setState({
            selectedRowKeys,
            users
          })
        } else {
          selectedRowKeys.push(item.user_id)
          users.push(item)
          this.setState({
            selectedRowKeys,
            users
          })
        }
      }
    };
  }

  render() {
    const { goodsList, memberList, selectedRowKeys, selectedRowKey, goods, count } = this.state;
    const materialRowSelection = {
      selectedRowKeys: selectedRowKey,
      onChange: this.onGoodsSelectChange,
      type: 'radio'
    };
    const userRowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return (
      <div className="award_distribution" id="award_distribution">
        <h3>奖励发放</h3>
        <div className="main">
          <Table
            // bordered
            onRow={this.handleGoodsRow}
            size="small"
            rowKey={record => record.item_id}
            rowSelection={materialRowSelection}
            columns={columns}
            dataSource={goodsList} />
          <Table
            // bordered
            size="small"
            onRow={this.handleUsersRow}
            rowKey={record => record.user_id}
            rowSelection={userRowSelection}
            columns={userColumns}
            dataSource={memberList} />
          <Descriptions column={1}>
            <Descriptions.Item label="发放物品">{goods.item_name}</Descriptions.Item>
            <Descriptions.Item label="发放数量">
              {count * selectedRowKeys.length}
                个
            </Descriptions.Item>
            <Descriptions.Item label="发放用户">
              {selectedRowKeys.length}
                名
            </Descriptions.Item>
            <Descriptions.Item label="发放量"><InputNumber min={1} defaultValue={count} onChange={this.onChange} /></Descriptions.Item>
            <Descriptions.Item ><Button type="primary" onClick={this.handleSubmit}>提交</Button></Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    );
  }
}

export default AwardDistribution;
